(function () {

function render_need_help (previous_cont) {
  const need_help_cont = document.createElement('div');
  need_help_cont.className = "need_help_cont";
  previous_cont.after(need_help_cont);
  
  const need_help_link = document.createElement('div');
  need_help_link.className = 'need_help_link';
  need_help_link.innerHTML = 'need help';
  need_help_cont.appendChild(need_help_link);

  const need_help = document.createElement('div');
  need_help.className = 'need_help';
  need_help.innerHTML = `
    <p>please call our team:  <a href="tel:+61342412314" style="text-decoration: underline; text-underline-position: under; color: #0047AB;">+61 3 4241 2314</a></p>
    <p>or email us: <a style="text-decoration: underline; text-underline-position: under; color: #0047AB;" href="mailto:info@needessentials.com?subject=needessentials%20-%20help%20with%20choosing%20the%20best%20wetsuit&body=Hi%2C%20thanks%20for%20reaching%20out%21%0A%0APlease%20fill%20out%20the%20following%20details%20then%20hit%20send%20and%20we%27ll%20get%20back%20to%20you%20as%20soon%20as%20possible%20with%20expert%20advice%20to%20get%20you%20into%20the%20best%20wetsuit%20or%20provide%20further%20information%20about%20our%20surf%20accessories%20and%20expedition%20clothing%0A%0AAlternatively%2C%20we%20are%20always%20pleased%20to%20speak%20directly%20any%20time%20between%209am%20and%205pm%20%28AEST%29%20Monday%20to%20Friday%20on%20+61%203%204241%202314.%0A%0AWe%20look%20forward%20to%20hearing%20from%20you%2C%0A%0Aneedessentials%20-%20Customer%20Service%0A%0A-----------%0A%0AHi%20needessentials%20team%21%0A%0AI%20require%20some%20assistance%20choosing%20the%20best%20wetsuit.%0A%0ATo%20assist%20here%20are%20details%20of%3A%0A%0AMy%20height%3A%0A%0AMy%20weight%3A%0A%0AMy%20age%3A%0A%0ASize%20and%20brand%20wetsuit%20I%27ve%20worn%20previously%3A%0A%0AWhere%20and%20when%20I%20will%20use%20the%20wetsuit%3A%0A%0AWhether%20I%27m%20purchasing%20the%20wetsuit%20for%20surfing%20or%20other%20water%20activities%3A%0A%0AAny%20other%20advice%20requested%3A%0A%0AI%27d%20like%20needessentials%20product%20phone%20consultation%20and%20the%20best%20number%20to%20reach%20me%20on%20is%3A%20%20">info@needessentials.com</a></p>
  `;
  need_help_cont.appendChild(need_help);
  
  let need_help_is_visible = false;
  
  function help_visibility () {
    if (!need_help_is_visible) {
      need_help.style.display = 'block';
      need_help_link.innerHTML = 'close help';
      need_help_is_visible = true;
    }
    else {
      need_help.style.display = 'none';
      need_help_link.innerHTML = 'need help';
      need_help_is_visible = false;
    }
  }
  need_help_link.addEventListener('click', help_visibility);
}

window.render_need_help = render_need_help;

})()
